import { Box, ButtonBase, Icon, styled, useMediaQuery } from "@mui/material";
import useSettings from "app/hooks/useSettings";
import React, { Fragment, useContext } from "react";
import { NavLink } from "react-router-dom";
import { Paragraph, Span } from "../Typography";
import MatxVerticalNavExpansionPanel from "./MatxVerticalNavExpansionPanel";
import { TitleContext } from "app/contexts/titleContext";

const ListLabel = styled(Paragraph)(({ theme, mode }) => ({
  fontSize: "12px",
  marginTop: "20px",
  marginLeft: "15px",
  marginBottom: "10px",
  textTransform: "uppercase",
  display: mode === "compact" && "none",
  color: theme.palette.text.secondary,
}));

const ExtAndIntCommon = {
  display: "flex",
  overflow: "hidden",
  height: 44,
  whiteSpace: "pre",
  marginBottom: "3px",
  textDecoration: "none",
  justifyContent: "space-between",
  transition: "all 150ms ease-in",
  borderRadius: "8px",
  "&:hover": { background: "#FFFFFF" },
  "&.compactNavItem": {
    overflow: "hidden",
    justifyContent: "center !important",
  },
  "& .icon": {
    fontSize: "18px",
    paddingLeft: "16px",
    paddingRight: "16px",
    verticalAlign: "middle",
  },
};

const ExternalLink = styled("a")(({ theme }) => ({
  ...ExtAndIntCommon,
  color: theme.palette.text.primary,
}));

const InternalLink = styled(Box)(({ theme, mode }) => ({
  "& a": {
    ...ExtAndIntCommon,
    color: theme.palette.text.primary,
    height: "42px",
  },
  "& .navItemActive": {
    backgroundColor: "#FFFFFF",
    boxShadow: 'inset 0 0 6px gray',
    "& .sidenavHoverShow": {
      display: mode == !"compact" ? "block" : "",
      color:
        localStorage.getItem("ColorCode") === "#7893CF"
          ? "#333333"
          : localStorage.getItem("ColorCode") === "#198DCB"
          ? "#333333"
          : localStorage.getItem("ColorCode") === "#62AAC5"
          ? "#333333"
          : localStorage.getItem("ColorCode") === "#51A1DA"
          ? "#333333"
          : localStorage.getItem("ColorCode") === "#5A89F3"
          ? "#333333"
          : localStorage.getItem("ColorCode") === "#396CDF"
          ? "#333333"
          : localStorage.getItem("StudentColorUpdate") === "#7893CF"
          ? "#333333"
          : localStorage.getItem("StudentColorUpdate") === "#198DCB"
          ? "#333333"
          : localStorage.getItem("StudentColorUpdate") === "#62AAC5"
          ? "#333333"
          : localStorage.getItem("StudentColorUpdate") === "#51A1DA"
          ? "#333333"
          : localStorage.getItem("StudentColorUpdate") === "#5A89F3"
          ? "#333333"
          : localStorage.getItem("StudentColorUpdate") === "#396CDF"
          ? "#333333"
          : "",
    },
    "& .iconwhite": {
      filter:
        "brightness(0) saturate(100%) hue-rotate(0deg) invert(0%) sepia(100%) saturate(100%) contrast(100%)",
    },
  },
  "&:hover": {
    "& .sidenavHoverShow": {
      color:
        localStorage.getItem("ColorCode") === "#7893CF"
          ? "#333333"
          : localStorage.getItem("ColorCode") === "#198DCB"
          ? "#333333"
          : localStorage.getItem("ColorCode") === "#62AAC5"
          ? "#333333"
          : localStorage.getItem("ColorCode") === "#51A1DA"
          ? "#333333"
          : localStorage.getItem("ColorCode") === "#5A89F3"
          ? "#333333"
          : localStorage.getItem("ColorCode") === "#396CDF"
          ? "#333333"
          : localStorage.getItem("StudentColorUpdate") === "#7893CF"
          ? "#333333"
          : localStorage.getItem("StudentColorUpdate") === "#198DCB"
          ? "#333333"
          : localStorage.getItem("StudentColorUpdate") === "#62AAC5"
          ? "#333333"
          : localStorage.getItem("StudentColorUpdate") === "#51A1DA"
          ? "#333333"
          : localStorage.getItem("StudentColorUpdate") === "#5A89F3"
          ? "#333333"
          : localStorage.getItem("StudentColorUpdate") === "#396CDF"
          ? "#333333"

          : "",
    },
    "& .iconwhite": {
      filter:
        "brightness(0) saturate(100%) hue-rotate(0deg) invert(0%) sepia(100%) saturate(100%) contrast(100%)",
    },
  },
}));

const StyledText = styled(Span)(({ mode }) => ({
  paddingLeft: "0.8rem",
  color:
    localStorage.getItem("ColorCode") === "#7893CF"
      ? "#FFFFFF"
      : localStorage.getItem("ColorCode") === "#198DCB"
      ? "#FFFFFF"
      : localStorage.getItem("ColorCode") === "#62AAC5"
      ? "#FFFFFF"
      : localStorage.getItem("ColorCode") === "#51A1DA"
      ? "#FFFFFF"
      : localStorage.getItem("ColorCode") === "#5A89F3"
      ? "#FFFFFF"
      : localStorage.getItem("ColorCode") === "#396CDF"
      ? "#FFFFFF"
      : localStorage.getItem("StudentColorUpdate") === "#7893CF"
      ? "#FFFFFF"
      : localStorage.getItem("StudentColorUpdate") === "#198DCB"
      ? "#FFFFFF"
      : localStorage.getItem("StudentColorUpdate") === "#62AAC5"
      ? "#FFFFFF"
      : localStorage.getItem("StudentColorUpdate") === "#51A1DA"
      ? "#FFFFFF"
      : localStorage.getItem("StudentColorUpdate") === "#5A89F3"
      ? "#FFFFFF"
      : localStorage.getItem("StudentColorUpdate") === "#396CDF"
      ? "#FFFFFF"
      : "#333333",
  fontFamily: "Poppins",
  fontSize: mode === "mobile" ? "12px" : "14px",
  fontWeight: "400",
  display: mode === "compact" && "none",
}));

const BulletIcon = styled("div")(({ theme }) => ({
  padding: "2px",
  marginLeft: "24px",
  marginRight: "8px",
  overflow: "hidden",
  borderRadius: "300px",
  background: theme.palette.text.primary,
}));

const BadgeValue = styled("div")(() => ({
  padding: "1px 8px",
  overflow: "hidden",
  borderRadius: "300px",
}));

const MatxVerticalNav = ({ items, onCloseSidebar }) => {
  const { settings } = useSettings();
  const { mode } = settings.layout1Settings.leftSidebar;
  const downLg = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const { ColorCode } = useContext(TitleContext);

  ColorCode && localStorage.setItem("ColorCode", ColorCode);

  const renderLevels = (data) => {
    return data.map((item, index) => {
      if (item.type === "label")
        return (
          <ListLabel key={index} mode={mode} className="sidenavHoverShow">
            {item.label}
          </ListLabel>
        );
      if (item.children) {
        return (
          <MatxVerticalNavExpansionPanel mode={mode} item={item} key={index}>
            {renderLevels(item.children)}
          </MatxVerticalNavExpansionPanel>
        );
      } else if (item.type === "extLink") {
        return (
          <ExternalLink
            key={index}
            href={item.path}
            className={`${mode === "compact" && "compactNavItem"}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            <ButtonBase key={item.name} name="child" sx={{ width: "100%" }}>
              {(() => {
                if (item.icon) {
                  return <Icon className="icon">{item.icon}</Icon>;
                } else {
                  return (
                    <span className="item-icon icon-text">{item.iconText}</span>
                  );
                }
              })()}
              <StyledText mode={mode} className="sidenavHoverShow">
                {item.name}
              </StyledText>
              <Box mx="auto"></Box>
              {item.badge && <BadgeValue>{item.badge.value}</BadgeValue>}
            </ButtonBase>
          </ExternalLink>
        );
      } else {
        return (
          <InternalLink key={index}>
            <NavLink
              to={item.path}
              {...(downLg && { onClick: onCloseSidebar })}
              className={({ isActive }) =>
                isActive
                  ? `navItemActive ${mode === "compact" && "compactNavItem"}`
                  : item.path.replace(/^\/([^\/]*).*$/, "$1") ===
                    window.location.pathname.replace(/^\/([^\/]*).*$/, "$1")
                  // ? `navItemActive ${mode === "compact" && "compactNavItem"}`
                  // : `${mode === "compact" && "compactNavItem"}`
              }
            >
              <ButtonBase key={item.name} name="child" sx={{ width: "100%" }}>
                {item?.icon ? (
                  localStorage.getItem("ColorCode") === "#7893CF" ||
                  localStorage.getItem("ColorCode") === "#198DCB" ||
                  localStorage.getItem("ColorCode") === "#62AAC5" ||
                  localStorage.getItem("ColorCode") === "#51A1DA" ||
                  localStorage.getItem("ColorCode") === "#5A89F3" ||
                  localStorage.getItem("ColorCode") === "#396CDF" ||
                  localStorage.getItem("StudentColorUpdate") === "#7893CF" ||
                  localStorage.getItem("StudentColorUpdate") === "#198DCB" ||
                  localStorage.getItem("StudentColorUpdate") === "#62AAC5" ||
                  localStorage.getItem("StudentColorUpdate") === "#51A1DA" ||
                  localStorage.getItem("StudentColorUpdate") === "#5A89F3" ||
                  localStorage.getItem("StudentColorUpdate") === "#396CDF" ? (
                    <Icon className="icon" sx={{ width: 36, height: "1.09em" }}>
                      <img
                        style={{ width: mode === "mobile" ? 14 : 16 }}
                        src={item.icon[1]}
                        alt=""
                        className="iconwhite"
                      />
                    </Icon>
                  ) : (
                    <Icon className="icon" sx={{ width: 36, height: "1.09em" }}>
                      <img
                        style={{ width: mode === "mobile" ? 14 : 16 }}
                        src={item.icon[0]}
                        alt=""
                      />
                    </Icon>
                  )
                ) : (
                  <Fragment>
                    <BulletIcon
                      className={`nav-bullet`}
                      sx={{ display: mode === "compact" && "none" }}
                    />
                    <Box
                      className="nav-bullet-text"
                      sx={{
                        ml: "20px",
                        fontSize: "11px",
                        display: mode !== "compact" && "none",
                      }}
                    >
                      {item.iconText}
                    </Box>
                  </Fragment>
                )}

                <StyledText mode={mode} className="sidenavHoverShow">
                  {item.name}
                </StyledText>

                <Box mx="auto"></Box>
                {item.badge && (
                  <BadgeValue className="sidenavHoverShow">
                    {item.badge.value}
                  </BadgeValue>
                )}
              </ButtonBase>
            </NavLink>
          </InternalLink>
        );
      }
    });
  };

  return <div className="navigation">{renderLevels(items)}</div>;
};

export default React.memo(MatxVerticalNav);
